import React from 'react';
export function StickyAlertBar() {
  const text = '🔥 LIMITED LAUNCH OFFER — 5 FREE BONUSES TODAY ONLY 🔥 · Instant Download · 14-Day Money Back Guarantee · ';
  return <div className="fixed top-0 left-0 right-0 z-50 bg-primary text-white h-10 flex items-center overflow-hidden" data-id="element-281">
      <div className="animate-marquee flex whitespace-nowrap" data-id="element-282">
        <span className="mx-4 text-sm font-medium tracking-wide" data-id="element-283">
          {text}
          {text}
          {text}
          {text}
        </span>
        <span className="mx-4 text-sm font-medium tracking-wide" data-id="element-284">
          {text}
          {text}
          {text}
          {text}
        </span>
      </div>
    </div>;
}